export function getUrlSearchParams() {
  const searchQuery = window.location.search;
  return new URLSearchParams(searchQuery);
}

export function updateUrlSearchParams(pairs) {
  const urlSearchParams = getUrlSearchParams();

  Object.entries(pairs).forEach(([key, value]) => {
    if (value !== null && typeof value !== 'undefined') {
      urlSearchParams.set(key, value);
    } else {
      urlSearchParams['delete'](key);
    }
  });

  const currentUrl = window.location.origin + window.location.pathname;
  const newQueryString = urlSearchParams.toString();
  window.history.replaceState(null, null, currentUrl + (newQueryString ? `?${newQueryString}` : ''));
}

export function getUrlLocale() {
  return window.location.pathname.split('/')[1] || 'en';
}
